export const STRIPE_CREATE_PAYMENT_INTENT = 'GIFTYA/STRIPE_CREATE_PAYMENT_INTENT';
export const STRIPE_CREATE_PAYMENT_INTENT_RESET = 'GIFTYA/STRIPE_CREATE_PAYMENT_INTENT_RESET';
export const STRIPE_UPDATE_PAYMENT_INTENT = 'GIFTYA/STRIPE_UPDATE_PAYMENT_INTENT';
export const STRIPE_UPDATE_PAYMENT_INTENT_RESET = 'GIFTYA/STRIPE_UPDATE_PAYMENT_INTENT_RESET';
export const STRIPE_UPDATE_BILLING_ADDRESS = 'GIFTYA/STRIPE_UPDATE_BILLING_ADDRESS';
export const STRIPE_UPDATE_BILLING_ADDRESS_RESET = 'GIFTYA/STRIPE_UPDATE_BILLING_ADDRESS_RESET';

export const updateBillingAddress = (payload, meta = {}, error = false) => ({
    type: STRIPE_UPDATE_BILLING_ADDRESS,
    payload,
    meta,
    error
});
export const updateBillingAddressReset = (payload, meta, error) => ({
    type: STRIPE_UPDATE_BILLING_ADDRESS_RESET,
    payload,
    meta,
    error
});
export const createPaymentIntent = (payload, meta = {}, error = false) => ({
    type: STRIPE_CREATE_PAYMENT_INTENT,
    payload,
    meta,
    error
});
export const createPaymentIntentReset = (payload, meta, error) => ({
    type: STRIPE_CREATE_PAYMENT_INTENT_RESET,
    payload,
    meta,
    error
});
export const updatePaymentIntent = (payload, meta = {}, error = false) => ({
    type: STRIPE_UPDATE_PAYMENT_INTENT,
    payload,
    meta,
    error
});
export const updatePaymentIntentReset = (payload, meta, error) => ({
    type: STRIPE_UPDATE_PAYMENT_INTENT_RESET,
    payload,
    meta,
    error
});